// extracted by mini-css-extract-plugin
export var icon = "NoEvents-module--icon--5e94f";
export var margin = "NoEvents-module--margin--907dd";
export var narrow = "NoEvents-module--narrow--71deb";
export var root = "NoEvents-module--root--92e97";